import { sec } from './units.ts';

/**
 * Ragna, the Horn (barbarian; docs/ANTIHEROES.md): she went out through the gate to hunt them, alone. The fastest of
 * the Unsleeping: she leaps on whoever shoots from afar, her horn breaks the heroes' nerve and lifts the nightmares,
 * and her ultimate is a whirlwind nothing stops. Every share of a hero's health goes through armour and shields.
 */
export const RAGNA = {
  /** Her blow: at least this share of the struck hero's max health. */
  blowMaxHpBp: 900,
  /** Fury that doesn't ebb (passive): every tenth of her life lost, she hits this much harder (bp). */
  furyPerTenthBp: 400,
  /** ...and she mends on what she deals: `dealtBp` of it, and never less than `minMaxHpBp` of her own life a hit. */
  lifesteal: { dealtBp: 10000, minMaxHpBp: 30 },
  /**
   * Leap: onto the hero who shoots from farthest (a reach of `rangedFrom` or more) within `range` (not nearer than
   * `minRange`), else the most wounded; she flies `ticks` and lands on a marked ring of `radius` that strikes and stuns.
   * From her second phase, two leaps in a row.
   */
  leap: { every: sec(6), range: 7000, minRange: 1500, rangedFrom: 2500, ticks: 8, radius: 1300, damage: 80, maxHpBp: 1500, stun: sec(1), hunt: sec(4) },
  /** Horn: heroes within `radius` lose their nerve for `fear`; nightmares within `rallyRadius` are lifted (bannerman's boon) for `rally`. */
  horn: { every: sec(12), radius: 3500, fear: sec(2), rallyRadius: 5000, rally: sec(6) },
  /**
   * The lone sally (ultimate): after the cry, `ticks` of whirlwind toward the nearest hero (`step` a tick) that nothing
   * holds; every `every` ticks it strikes all heroes within `radius` (and structures, `structure` each).
   */
  sally: { range: 6000, ticks: sec(4), every: 6, radius: 1500, step: 170, damage: 50, maxHpBp: 700, structure: 60 },
  /** Frenzy (her last phase): she strikes this much sooner (bp of her reload). */
  frenzyReloadBp: 5500,
};
